export const MEMORY_USAGE_INSTRUMENTATION_NAME = 'memory_usage';
export const MEMORY_USAGE_INSTRUMENTATION_VERSION = '1.0.0';
export const MEMORY_USAGE_DEFAULT_INTERVAL = 300000; // 5 minutes;
export function isMeasureUserAgentSpecificMemoryAllowed() {
    if (!window.crossOriginIsolated) {
        console.debug('Coralogix Browser SDK - measureUserAgentSpecificMemory() is only available in cross-origin-isolated pages.');
        return false;
    }
    if (!performance.measureUserAgentSpecificMemory) {
        console.debug('Coralogix Browser SDK - measureUserAgentSpecificMemory() is not available in this browser');
        return false;
    }
    return true;
}
